// BEE-18: Hero section — headline, body copy, dual CTAs, logo divider
import type { CSSProperties } from 'react'
import { Link } from 'react-router-dom'

const HERO_BG: CSSProperties = {
  background: [
    'radial-gradient(900px 500px at 75% -5%, #f0e9d6 0%, transparent 60%)',
    'radial-gradient(700px 400px at -5% 15%, #e8efe9 0%, transparent 55%)',
    '#fbf9f4',
  ].join(', '),
}

export default function Hero() {
  return (
    <>
      {/* ── Hero ── */}
      <section style={HERO_BG} className="pt-14 pb-16 sm:pt-20 sm:pb-24 px-6 text-center overflow-x-hidden">
        <div className="max-w-[700px] mx-auto">

          {/* Eyebrow */}
          <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-green-700 mb-5">
            Care coordination, simplified
          </p>

          {/* Headline */}
          <h1 className="font-serif font-semibold text-[42px] sm:text-[54px] lg:text-[66px] leading-[1.02] tracking-[-0.022em] text-green-900 mb-6">
            Your village,<br />
            <em className="not-italic italic font-medium text-green-700">synchronized</em>
          </h1>

          {/* Body copy */}
          <p className="text-[17px] text-[#4a4d47] leading-[1.65] mb-9 max-w-[500px] mx-auto">
            Caring for someone you love takes a village. KindredCanopy brings family and friends
            together to coordinate meals, rides, visits, and support — so no one carries the load alone.
          </p>

          {/* CTA buttons */}
          <div className="flex items-center justify-center gap-3 flex-wrap">
            <Link
              to="/enroll"
              className="inline-flex items-center px-6 py-[13px] rounded-full bg-[#1f4029] text-white text-[15px] font-semibold hover:bg-[#2d5a3d] transition-colors duration-150 shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-500 focus-visible:ring-offset-2"
            >
              Create your canopy — free
            </Link>
            <Link
              to="/sign-in"
              className="inline-flex items-center px-6 py-[13px] rounded-full bg-[#c89b3c] text-[#2a1f08] text-[15px] font-semibold hover:bg-[#b88a2c] transition-colors duration-150 shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#c89b3c] focus-visible:ring-offset-2"
            >
              Log in
            </Link>
          </div>

          {/* Fine print */}
          <p className="text-[12.5px] text-[#a6a89e] mt-4">
            Free forever. No credit card required.
          </p>

        </div>
      </section>

      {/* ── Logo divider ── */}
      <div className="flex justify-center items-center py-6 bg-paper px-6">
        <img
          src="/Logo_NoText.png"
          alt="KindredCanopy"
          className="w-full max-w-[400px] h-auto block"
          fetchPriority="high"
          width="800"
          height="516"
        />
      </div>
    </>
  )
}
